import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  IGenerateScanKey,
  InviteMembersModelPayload,
  InviteMembersResponse,
  UserBindingModel,
} from './UserServices/userInfo.model';
import { of } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { IGetBillingInfo } from '../../content/layout/shared/billing-address-confirmation-model/billing-address-confirmation-model..modal';

@Injectable({ providedIn: 'root' })
export class UserService {
  private http = inject(HttpClient);

  API_URL = environment.apiBaseAddress + '/UserService';
  SETTINGS_API_URL = `${environment.apiBaseAddress}/SettingService`;

  public getUserInfo() {
    return this.http.request<Response>('get', this.API_URL + '/GetUserInfo').pipe(
      flatMap(response => {
        const result = UserBindingModel.fromJS(response);
        return of(result);
      })
    );
  }
  public generateScanKey() {
    return this.http.get<IGenerateScanKey>(`${this.SETTINGS_API_URL}/GenerateApplicationScanKey`);
  }

  public getScanKey() {
    return this.http.get<IGenerateScanKey>(`${this.SETTINGS_API_URL}/GetApplicationScanKey`);
  }

  public getUserList(pageSize, pageNumber, parentRole, searchValue) {
    return this.http.request<any>(
      'get',
      `${
        this.API_URL
      }/GetUserList?row=${pageSize}&pageNumber=${pageNumber}&parentRole=${parentRole}&searchValue=${searchValue}`
    );
  }

  public changeUserRole(roleType, objModel) {
    return this.http.get<any>(`${this.API_URL}/ChangeUserRole/${objModel.userId}/${roleType}`);
  }

  public changeUserInvitationRole(roleType, objModel) {
    return this.http.get<any>(
      `${this.API_URL}/ChnageUserInvitationRole/${objModel.userId}/${roleType}`
    );
  }

  public sendUserInvitation(objModel: InviteMembersModelPayload[]) {
    return this.http.post<InviteMembersResponse>(`${this.API_URL}/SendUserInvitation`, objModel);
  }

  public reSendUserInvitation(objModel) {
    var userInviteModel = {
      firstName: objModel.firstName,
      lastName: objModel.lastName,
      email: objModel.email,
      userId: objModel.userId,
    };
    return this.http.post<any>(`${this.API_URL}/ReSendUserInvitation`, userInviteModel);
  }

  public deleteUser(objModel) {
    return this.http.delete<any>(`${this.API_URL}/DeleteUser/${objModel.userId}`);
  }

  public deleteUserInvite(objModel) {
    return this.http.delete<any>(`${this.API_URL}/DeleteUserInvite/${objModel.userId}`);
  }

  public getUserRoleWebsitesListByUser() {
    return this.http.get<any>(`${this.API_URL}/GetUserRoleWebsitesListByUser`);
  }

  public getEventPromoters(eventIdentifier, pageNumber, pageSize) {
    var params = {
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    return this.http.get<any>(`${this.API_URL}/GetEventPromoters/${eventIdentifier}`, {
      params: params,
    });
  }

  public getAllPromoters(eventIdentifier) {
    return this.http.get<any>(`${this.API_URL}/GetAllPromoters/${eventIdentifier}`);
  }

  public addEventPromoter(body) {
    return this.http.post<any>(`${this.API_URL}/AddEventPromoter`, body);
  }

  public deleteEventPromoter(promoterId) {
    var params = {
      promoterId: promoterId,
    };
    return this.http.delete<any>(`${this.API_URL}/DeleteEventPromoter`, {
      params: params,
    });
  }

  sendReferralEmail(email) {
    return this.http.post<any>(`${this.API_URL}/SendReferralEmail`, email);
  }

  getBillingInformation() {
    return this.http.get<IGetBillingInfo>(`${this.API_URL}/GetBillingInformation`);
  }

  public deleteleCurrentUser(userRoleWebsiteId: number) {
    return this.http.delete<any>(`${this.API_URL}/DeleteCurrentUser/${userRoleWebsiteId}`);
  }

  public requestOwnershipTransferOTP() {
    return this.http.post<any>(`${this.API_URL}/RequestOwnershipTransferOTP`, {});
  }

  public completeOwnershipTransfer(model: any) {
    return this.http.post<any>(`${this.API_URL}/CompleteOwnershipTransfer`, model);
  }

  public getAdministrators() {
    return this.http.get<any>(`${this.API_URL}/GetAdministrators`);
  }
}
